/**
 * FollowupStatusBadge — color-coded pill for `followup_executions.status`
 * (Story 7.14, reused by 7.10b).
 *
 * Palette (from epic-E4B-followup-audit.md):
 *   sent              → green
 *   failed            → red
 *   skipped_window    → amber
 *   skipped_opted_out → gray
 *   skipped_24h_gate  → orange
 */

export type FollowupExecutionStatus =
  | 'sent'
  | 'failed'
  | 'skipped_window'
  | 'skipped_opted_out'
  | 'skipped_24h_gate';

const PALETTE: Record<FollowupExecutionStatus, string> = {
  sent: 'bg-green-500/20 text-green-700 dark:text-green-300',
  failed: 'bg-red-500/20 text-red-700 dark:text-red-300',
  skipped_window: 'bg-amber-500/20 text-amber-700 dark:text-amber-300',
  skipped_opted_out: 'bg-muted text-muted-foreground',
  skipped_24h_gate: 'bg-orange-500/20 text-orange-700 dark:text-orange-300',
};

export function FollowupStatusBadge({ status }: { status: FollowupExecutionStatus }) {
  const palette = PALETTE[status] ?? 'bg-muted text-muted-foreground';
  return (
    <span
      data-testid={`followup-status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${palette}`}
    >
      {status}
    </span>
  );
}
